<script setup lang="ts">
import { computed } from 'vue'
import Button from '../../mixit-ui/components/button/Button.vue'
import FreeDeliveryBar from '../cart/FreeDeliveryBar.vue'
import ProductCardCartMini from '../product-card/ProductCardCartMini.vue'
import { useCartStore } from '@/stores/CartStore'

const cartStore = useCartStore()

const items = computed(() => cartStore.getCartProducts)
const currentAmount = computed(() => cartStore.cart.productPrice)
const freeDeliveryThreshold = computed(() => cartStore.cart.productPrice + cartStore.cart.priceUntilFreeTransport)
</script>

<template>
  <div class="flex flex-col bg-white rounded-lg shadow overflow-hidden w-110 p-6 gap-6">
    <template v-if="items.length > 0">
      <div class="flex flex-col gap-4">
        <template
          v-for="(item, index) in items"
          :key="item.id"
        >
          <ProductCardCartMini :item="item" />
          <hr
            v-if="index < items.length - 1"
            class="border-brown-100"
          >
        </template>
      </div>

      <FreeDeliveryBar
        :current-amount="currentAmount"
        :threshold="freeDeliveryThreshold"
      />

      <Button
        label="Přejít do košíku"
        icon="mi-chevron-r"
        icon-pos="right"
        severity="success"
        size="md"
        to="/kosik"
        class="w-full"
      />
    </template>

    <div
      v-else
      class="flex flex-col items-center gap-2 py-4 text-center"
    >
      <i class="mi-cart-fill text-2xl text-brown-200" />
      <p class="font-roboto-slab font-bold text-sm text-brown-400">
        Košík je prázdný
      </p>
      <p class="font-montserrat text-xs text-brown-300">
        Zatím jste do košíku nic nepřidali.
      </p>
    </div>
  </div>
</template>
